<template>
    <g class="label-group"
       :class="labelClass()"
       ref="label-overlays">

        <rect class="label-drag-rect"
              :x="labelPositionX()"
              :y="labelPositionY()"
              :width="imageWidth()+'px'" :height="imageHeight()+'px'" rx="3" ry="3"
        />

        <rect class="label-overlays-select"
              :x="labelPositionX()"
              :y="labelPositionY()"
              :width="imageWidth()+'px'" :height="imageHeight()+'px'" rx="3" ry="3"
        />

        <line
                v-if="hasPointer"
                :x1="labelPositionX() + imageWidth() / 2"
                :y1="labelPositionY() + imageHeight() / 2"
                :x2="labelPositionPointerX()"
                :y2="labelPositionPointerY()"
        />
        <circle
                class="label-overlays-pointer"
                v-if="hasPointer && selected"
                :cx="labelPositionPointerX()"
                :cy="labelPositionPointerY()"
                r="8"
                :class="{'drag':dragPointer}"
                @mousedown="startDragPointer($event)"
                @mouseup="stopDragPointer()"
                ref="label-overlays-pointer"
        />

        <image :xlink:href="label.getImage()"
               :x="labelPositionX()"
               :y="labelPositionY()"
               :width="imageWidth()+'px'"
               :height="imageHeight()+'px'"
               @mouseenter="$emit('hover')"
               @mouseleave="stopDragDelay"
               @mousedown="startDrag($event)"
               @mouseup="stopDrag()"
               @click.stop="$emit('select')"
               @dblclick.stop="$emit('edit')"
               ref="label-overlays-image"
               preserveAspectRatio="none"
        />

        <circle
                v-if="selected"
                :cx="labelPositionX() + imageWidth()"
                :cy="labelPositionY() + imageHeight()"
                :r="8"
                class="resize-select"
                :class="{'drag':dragResize === 'homo'}"
                @mousedown="startDragResize($event,'homo')"
                @mouseup="stopDragResize()"
                ref="label-overlays-resize"
        />
        <circle
                v-if="selected"
                :cx="labelPositionX() + imageWidth() / 2"
                :cy="labelPositionY() + imageHeight()"
                :r="8"
                class="resize-select bottom"
                :class="{'drag':dragResize === 'height'}"
                @mousedown="startDragResize($event,'height')"
                @mouseup="stopDragResize()"
                ref="label-overlays-resize"
        />
        <circle
                v-if="selected"
                :cx="labelPositionX() + imageWidth()"
                :cy="labelPositionY() + imageHeight() / 2"
                :r="8"
                class="resize-select right"
                :class="{'drag':dragResize === 'width'}"
                @mousedown="startDragResize($event,'width')"
                @mouseup="stopDragResize()"
                ref="label-overlays-resize"
        />
    </g>
</template>

<script>
    import Tools from "../../class/tools";
    import {label} from "@/class/label";
    import events from "@/events/events";

    export default {
        name: "Overlays_Pointer",
        props: {
            label: {type:Object,default:() => new label()},
            imageData: {type: Object},
            selected: {type: Boolean},
            hovered: {type: Boolean}
        },
        data() {
            return {
                start: false,
                drag: false,
                dragMove:false,
                dragResize: "",
                dragPointer: false,
                dragOffset: {
                    x: 0,
                    y: 0
                },
                imageRatio: 0,
                imageLoaded:false,
                pointerCSS: "",
            }
        },
        methods: {
            loadImage(force) {

                if (this.imageRatio > 0 && !force) {
                    return;
                }

                let image = new Image();
                image.src = this.label.getImage();
                let t = this;
                image.onload = function () {
                    t.imageRatio = this.width / this.height;
                    t.imageLoaded = true;
    
                    if(t.label.getImageId() !== "") {
                        t.label.height = t.label.width / t.imageRatio;
                    }

                }
            },
            startDrag($event) {

                this.start = true;
                this.dragResize = "";
                this.dragPointer = false;
                this.dragOffset.x = $event.pageX - this.$refs["label-overlays-image"].getBoundingClientRect().left + 2;
                this.dragOffset.y = $event.pageY - this.$refs["label-overlays-image"].getBoundingClientRect().top;

                setTimeout(() => {
                    if (this.start) {
                        this.drag = true;
                        this.$emit('select');
                        this.$emit('drag');
                        events.$on("body:click:mouse:up",this.stopDrag)
                    }
                }, this.$store.getters.getDelayBeforeDrag)
            },
            stopDrag() {
                this.start = false;
    
                if(this.dragMove) {
                    this.label.save();
                }
                
                this.drag = false;
                this.dragMove = false;
                this.dragResize = "";
                this.dragPointer = false;
                this.$emit('undrag');
                events.$off("body:click:mouse:up",this.stopDrag)
            },
            stopDragDelay() {
                if (this.start && !this.drag) {
                    this.start = false;
                    this.drag = false;
                }
                if (!this.drag) {
                    this.$emit('unhover')
                }
            },
            startDragResize($event, type) {
                this.dragResize = type;
                // this.dragOffset.x = $event.pageX - this.$refs["label-overlays-resize"].getBoundingClientRect().left;
                // this.dragOffset.y = $event.pageY - this.$refs["label-overlays-resize"].getBoundingClientRect().top;
                this.$emit('drag');
                events.$on("body:click:mouse:up",this.stopDragResize)
            },
            stopDragResize() {
                this.dragResize = "";
                this.$emit('undrag');
                
                this.label.save();
                events.$off("body:click:mouse:up",this.stopDragResize)
            },
            startDragPointer($event) {
                this.dragOffset.x = $event.pageX - (this.$refs["label-overlays-pointer"].getBoundingClientRect().left + 7);
                this.dragOffset.y = $event.pageY - (this.$refs["label-overlays-pointer"].getBoundingClientRect().top + 7);
                this.dragPointer = true;
                this.$emit('drag');
                events.$on("body:click:mouse:up",this.stopDragPointer)
            },
            stopDragPointer() {
                this.dragPointer = false;
                this.$emit('undrag');
                
                this.label.save();
                events.$off("body:click:mouse:up",this.stopDragPointer)
            },
            labelClass() {

                let classe = this.label.getObjectType();
                if (this.start) {
                    classe += " start ";
                }
                if (this.drag) {
                    classe += " drag ";
                }
                if (this.selected) {
                    classe += " select ";
                }
                if (this.hovered) {
                    classe += " hover ";
                }

                return classe
            },
            labelPositionX() {
                let x = parseFloat(this.label.x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionY() {
                let y = parseFloat(this.label.y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
            imageWidth() {
                let width = parseFloat(this.label.width);
                width *= this.imageData.ratioX;
                return width;
            },
            imageHeight() {
                let height = parseFloat(this.label.height);
                height *= this.imageData.ratioY;
                return height;

            },
            labelPositionPointerX() {
                let x = parseFloat(this.label.pointer_x_coord);
                x *= this.imageData.ratioX;
                return x;
            },
            labelPositionPointerY() {
                let y = parseFloat(this.label.pointer_y_coord);
                y *= this.imageData.ratioY;
                return y;
            },
            lineDistance(x, y, x0, y0) {
                return Math.sqrt((x -= x0) * x + (y -= y0) * y);
            },
        },
        computed: {
            hasPointer() {
                return (this.label.pointer_x_coord != 0 && this.label.pointer_x_coord != null) && (this.label.pointer_y_coord != 0 && this.label.pointer_y_coord != null);
            }
        },
        watch: {
            '$store.state.mouse.position'(value) {

                let label = this.label;

                // drag text
                if (this.drag) {
                    label.x_coord = Tools.format(value.x - this.dragOffset.x,-100, this.imageData.width + 100,this.imageData.ratioX);
                    label.y_coord = Tools.format(value.y - this.dragOffset.y,-1000, this.imageData.height + 1000,this.imageData.ratioY);
    
                    if(this.hasPointer){
                        if(label.pointer_x_coord > (Number(label.x_coord) + (label.width / 2)) - 10 && label.pointer_x_coord < (Number(label.x_coord) + (label.width / 2)) + 10){
                            label.x_coord = (Number(label.pointer_x_coord) - (label.width / 2))
                        }
                        if(label.pointer_y_coord > (Number(label.y_coord) + Number(label.height / 2)) - 10 && label.pointer_y_coord < (Number(label.y_coord) + Number(label.height / 2)) + 10){
                            label.y_coord = (Number(label.pointer_y_coord) - Number(label.height / 2))
                        }
                    }
                    this.dragMove = true;
                }

                // drag pointer
                if (this.dragResize !== "") {

                    let newWidth = value.x - this.labelPositionX();
                    let newHeight = value.y - this.labelPositionY();

                    if (this.dragResize === "width" || this.dragResize === "homo") {
                        label.width = newWidth;
                        if(label.width < 0) label.width = 0;
                        label.width /= this.imageData.ratioX;
                        
                        // label.x_coord = Math.round(label.x_coord + label.width / 2)
                        // label.y_coord = Math.round(label.y_coord + label.width / 2)
                    }

                    if (this.dragResize === "height") {
                        label.height = newHeight;
                        if(label.height < 0) label.height = 0;
                        label.height /= this.imageData.ratioY;
                    }

                    if (this.dragResize === "homo") {
                        label.width = newWidth;
                        if(label.width < 0) label.width = 0;
                        label.height = label.width / this.imageRatio;
                        label.width /= this.imageData.ratioX;
                        label.height /= this.imageData.ratioY;
                    }

                    label.width = Math.round(label.width);
                    label.height = Math.round(label.height);

                }

                // drag pointer
                if (this.dragPointer) {
                    label.pointer_x_coord = Tools.format(value.x - this.dragOffset.x,1, this.imageData.width,this.imageData.ratioX);
                    label.pointer_y_coord = Tools.format(value.y - this.dragOffset.y,1, this.imageData.height,this.imageData.ratioY);
    
                    if(label.pointer_x_coord > (Number(label.x_coord) + (label.width / 2)) - 10 && label.pointer_x_coord < (Number(label.x_coord) + (label.width / 2)) + 10){
                        label.pointer_x_coord = (Number(label.x_coord) + (label.width / 2))
                    }
                    if(label.pointer_y_coord > (Number(label.y_coord) + Number(label.height / 2)) - 10 && label.pointer_y_coord < (Number(label.y_coord) + Number(label.height / 2)) + 10){
                        label.pointer_y_coord = (Number(label.y_coord) + Number(label.height / 2))
                    }
                }

            },
            'imageData.zoom'(){
                this.$forceUpdate();
            },
            'label.image'(){
                this.loadImage(true);
            },
            'imageData.width'(){
                this.$forceUpdate();
            },
            'imageData.height'(){
                this.$forceUpdate();
            },
        },
        mounted() {
            this.loadImage();
        }
    }
</script>